import React from 'react';
import { Link } from 'react-router-dom';
import { BadgeCheck, Contact, FileText, Presentation } from 'lucide-react';
import { useI18n } from '../../i18n/I18nContext';
import './Hero.css';

const OUTPUT_ICONS = [FileText, BadgeCheck, Contact, Presentation];

const Hero: React.FC = () => {
  const { content } = useI18n();
  const hero = content.hero;

  return (
    <section className="hero">
      <div className="container hero__layout">
        <div className="hero__content">
          <span className="hero__eyebrow">{hero.eyebrow}</span>
          <h1 className="hero__title">{hero.titleStart} <span>{hero.titleHighlight}</span></h1>
          <p className="hero__subtitle">{hero.subtitle}</p>
          <div className="hero__actions">
            <Link to="/request" className="btn btn-primary btn-lg">{hero.primary}</Link>
            <Link to="/services" className="btn btn-outline btn-lg">{hero.secondary}</Link>
          </div>
          <p className="hero__note">{hero.note}</p>
        </div>
        <div className="hero__panel" aria-label={hero.panelAria}>
          <div className="hero__panel-header">
            <div><span>{hero.panelLabel}</span><strong>{hero.panelTitle}</strong></div>
            <span className="hero__status">{hero.status}</span>
          </div>
          <p className="hero__brief">{hero.brief}</p>
          <div className="hero__outputs">
            {hero.outputs.map((output, index) => {
              const Icon = OUTPUT_ICONS[index];
              return (
                <div key={output.label} className="hero__output">
                  <span className="hero__output-icon"><Icon size={17} strokeWidth={1.7} /></span>
                  <span><strong>{output.label}</strong><small>{output.meta}</small></span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
